var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "810px",
    height: "811px",
    viewBox: "0 0 810 811",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cloud2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530,112 C530,112 527.164837,83.8149528 505.911096,80.4908293 C484.657356,77.1677059 485.71555,91.8012496 485.71555,91.8012496 C485.71555,91.8012496 485.366146,63.4631967 461.277243,56.7769483 C437.178356,50.0906999 442.499278,88.7581365 442.499278,88.7581365 L530,112",
    id: "Fill-14",
    fill: "#FFFCFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2);
export default __webpack_public_path__ + "static/media/Cloud2.015cbc742432fecfb8e79110a9e9928e.svg";
export { ForwardRef as ReactComponent };